module.exports = __webpack_public_path__ + "static/media/memberLevel4.8f034955.svg";